// API utility file for centralized axios configuration
// Uses environment variable for backend URL
import axios from 'axios';

// Get the API base URL from environment variables
// React requires environment variables to start with REACT_APP_
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

// Create an axios instance with default configuration
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor - adds authentication tokens to requests
api.interceptors.request.use(
  (config) => {
    // Add authentication token from localStorage if available
    const token = localStorage.getItem('adminToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor - handles authentication errors globally
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // If token is invalid or expired, remove it and redirect to login
    if (error.response?.status === 401) {
      localStorage.removeItem('adminToken');
      // Only redirect if we're on the admin page
      if (window.location.pathname === '/admin') {
        window.location.reload();
      }
    }
    return Promise.reject(error);
  }
);

export default api;

